/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var WebhookEvent;
(function (WebhookEvent) {
    /**
     * The event type. The type of event data will depend on the value present here.
     */
    let event_type;
    (function (event_type) {
        event_type["ORDER_RECEIVED"] = "order.received";
        event_type["ORDER_PLACED"] = "order.placed";
        event_type["ORDER_ALLOCATED"] = "order.allocated";
        event_type["ORDER_PAID"] = "order.paid";
        event_type["ORDER_CANCELLED"] = "order.cancelled";
        event_type["ORDER_FAILED"] = "order.failed";
        event_type["ORDER_COMPLETED"] = "order.completed";
    })(event_type = WebhookEvent.event_type || (WebhookEvent.event_type = {}));
})(WebhookEvent || (WebhookEvent = {}));
//# sourceMappingURL=WebhookEvent.js.map